// Accesibilidad del carrusel de portada (partials/frontpage/main.sbn).
// Owl Carousel lo inicializa assets/js/main.js; aquí solo se completa lo que Owl no hace:
// nombres accesibles en flechas y puntos, botón para pausar el pase automático (WCAG 2.2.2)
// y pausa automática si el usuario ha pedido reducir el movimiento.

type JQueryLike = (el: Element) => {
  on: (eventos: string, fn: () => void) => void;
  trigger: (evento: string) => void;
};

export const initCarrusel = (root?: HTMLElement) => {
  const carrusel = root?.querySelector<HTMLElement>('.owl-carousel');
  const jq = (window as unknown as { jQuery?: JQueryLike }).jQuery;
  if (!root || !carrusel || !jq) return;

  const $carrusel = jq(carrusel);
  let pausado = false;
  let botonPausa: HTMLButtonElement | null = null;

  const pintarBotonPausa = () => {
    if (!botonPausa) return;
    const texto = pausado ? 'Reanudar el pase de diapositivas' : 'Pausar el pase de diapositivas';
    botonPausa.setAttribute('aria-label', texto);
    botonPausa.setAttribute('aria-pressed', String(pausado));
    botonPausa.innerHTML = `<i class="fa-solid ${pausado ? 'fa-play' : 'fa-pause'}" aria-hidden="true"></i>`;
  };

  const pausar = () => {
    pausado = true;
    $carrusel.trigger('stop.owl.autoplay');
    pintarBotonPausa();
  };

  const reanudar = () => {
    pausado = false;
    $carrusel.trigger('play.owl.autoplay');
    pintarBotonPausa();
  };

  const etiquetar = () => {
    const total = carrusel.querySelectorAll('.owl-item:not(.cloned)').length;

    const anterior = carrusel.querySelector<HTMLElement>('.owl-nav .owl-prev');
    const siguiente = carrusel.querySelector<HTMLElement>('.owl-nav .owl-next');
    [[anterior, 'Diapositiva anterior'], [siguiente, 'Diapositiva siguiente']].forEach(([boton, texto]) => {
      if (!(boton instanceof HTMLElement)) return;
      boton.removeAttribute('role');
      boton.setAttribute('type', 'button');
      boton.setAttribute('aria-label', texto as string);
    });

    carrusel.querySelectorAll<HTMLElement>('.owl-dots .owl-dot').forEach((punto, i) => {
      punto.setAttribute('type', 'button');
      punto.setAttribute('aria-label', `Ir a la diapositiva ${i + 1} de ${total}`);
      if (punto.classList.contains('active')) punto.setAttribute('aria-current', 'true');
      else punto.removeAttribute('aria-current');
    });

    // Las copias que Owl crea para el bucle no deben leerse dos veces
    carrusel.querySelectorAll<HTMLElement>('.owl-item.cloned').forEach((copia) => copia.setAttribute('aria-hidden', 'true'));
  };

  const preparar = () => {
    etiquetar();

    const nav = carrusel.querySelector<HTMLElement>('.owl-nav');
    if (nav && !botonPausa) {
      botonPausa = document.createElement('button');
      botonPausa.type = 'button';
      botonPausa.className = 'portada-hero__pausa';
      botonPausa.addEventListener('click', () => (pausado ? reanudar() : pausar()));
      nav.prepend(botonPausa);
      pintarBotonPausa();
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) pausar();
  };

  // Owl vuelve a marcar el punto activo después de lanzar sus eventos, y al cambiar de
  // punto de ruptura reactiva el autoplay: si el usuario lo pausó, se vuelve a detener.
  $carrusel.on('changed.owl.carousel refreshed.owl.carousel translated.owl.carousel', () => {
    window.setTimeout(() => {
      etiquetar();
      if (pausado) $carrusel.trigger('stop.owl.autoplay');
    }, 0);
  });

  if (carrusel.classList.contains('owl-loaded')) preparar();
  else $carrusel.on('initialized.owl.carousel', preparar);
};
